export default __webpack_public_path__ + "static/media/inorout.725b594c.png";